<template>
  <div style="display: none;"></div>
</template>

<script setup>
import { onMounted } from 'vue'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

const generatePDF = async () => {
  try {
    // Créer un élément temporaire avec le contenu HTML optimisé
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = `<div ref="pdfContent" class="pdf-container">
  <!-- Contenu de la facture -->
  <div class="invoice">
    <table style="width: 100%; border-collapse: collapse; margin-bottom: 8px;">
      <tbody>
        <tr>
          <td rowspan="6" width="500" style="text-align: left; vertical-align: top;">
            <!-- <img :src="dataURL" alt=""> -->
          </td>
          <td width="300" style="text-align: right; vertical-align: top;">
            <h6 style="margin: 0; font-size: 14px;">FACTURE CLIENT</h6>
          </td>
        </tr>
        <tr>
          <td width="300" style="text-align: left; padding: 1px 0; font-size: 10px;">Souche: INVDE</td>
        </tr>
        <tr>
          <td width="300" style="text-align: left; padding: 1px 0; font-size: 10px;">Numéro: 000 000 438</td>
        </tr>
        <tr>
          <td width="300" style="text-align: left; padding: 1px 0; font-size: 10px;">Page: 1</td>
        </tr>
        <tr>
          <td width="300" style="text-align: left; padding: 1px 0; font-size: 10px;">Date de saisie: 08/04/2025</td>
        </tr>
        <tr>
          <td width="300" style="text-align: left; padding: 1px 0; font-size: 10px;">Code client: INFL199</td>
        </tr>
      </tbody>
    </table>

    <!-- Société -->
    <div class="company" style="margin-bottom: 8px; font-size: 10px; line-height: 1.2;">
      <h3 style="margin: 0 0 4px 0; font-size: 12px;">AD INTERNATIONAL SAS</h3>
      <div style="padding: 0.5px 0;">Parc d'activité de la Verte Rue</div>
      <div style="padding: 0.5px 0;">52 Allée des Prêtes</div>
      <div style="padding: 0.5px 0;">59270 BAILLEUL</div>
      <div style="padding: 0.5px 0;">FRANCE</div>
      <div style="padding: 0.5px 0;">Tel: +33.3.28.42.56.94</div>
      <div style="padding: 0.5px 0;">adv@adinternational.fr</div>
    </div>

    <!-- Informations bancaires -->
    <div class="bank-info" style="margin-bottom: 8px; font-size: 9px; line-height: 1.1;">
      <div style="padding: 0.5px 0;"><strong>IBAN:</strong> FR76 3000 4005 5700 0100 0388 977</div>
      <div style="padding: 0.5px 0;"><strong>BIC:</strong> BNP-AFRPPNFE</div>
      <div style="padding: 0.5px 0;"><strong>TVA:</strong> FR14 419 393 916</div>
      <div style="padding: 0.5px 0;"><strong>SBET:</strong> 419 393 916 0026</div>
      <div style="padding: 0.5px 0;"><strong>REC:</strong> fascination 419 393 916 n° gestion 98 B 80</div>
      <div style="padding: 0.5px 0;">SAS au capital de 125 000 euros</div>
    </div>

    <hr style="margin: 6px 0; border: 0.5px solid #000;">

    <!-- Adresse de livraison -->
    <div class="delivery-address" style="margin-bottom: 8px;">
      <table style="width: 100%; border-collapse: collapse; font-size: 10px;">
        <tbody>
          <tr>
            <td width="200" style="padding: 1px 0;"><strong>ADRESSE DE LIVRAISON</strong></td>
            <td width="400" style="padding: 1px 0;"></td>
            <td width="200" style="padding: 1px 0;"><strong>ADRESSE DE FACTURATION</strong></td>
          </tr>
          <tr>
            <td width="200" style="padding: 0.5px 0;">DEDEL</td>
            <td width="400" style="padding: 0.5px 0;"></td>
            <td width="200" style="padding: 0.5px 0;">DEDEL</td>
          </tr>
          <tr>
            <td width="200" style="padding: 0.5px 0;">61 Rue Saint Jean Du Perot</td>
            <td width="400" style="padding: 0.5px 0;"></td>
            <td width="200" style="padding: 0.5px 0;">61 Rue Saint Jean Du Perot</td>
          </tr>
          <tr>
            <td width="200" style="padding: 0.5px 0;">&nbsp;</td>
            <td width="400" style="padding: 0.5px 0;"></td>
            <td width="200" style="padding: 0.5px 0;">&nbsp;</td>
          </tr>
          <tr>
            <td width="200" style="padding: 0.5px 0;">17000 LA ROCHELLE</td>
            <td width="400" style="padding: 0.5px 0;"></td>
            <td width="200" style="padding: 0.5px 0;">17000 LA ROCHELLE</td>
          </tr>
          <tr>
            <td width="200" style="padding: 0.5px 0;">FRANCE</td>
            <td width="400" style="padding: 0.5px 0;"></td>
            <td width="200" style="padding: 0.5px 0;">FRANCE</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Informations commerciales -->
    <div class="commercial-info" style="margin-bottom: 8px; font-size: 10px; line-height: 1.2;">
      <div style="padding: 0.5px 0;"><strong>REPRÉSENTATION:</strong> COMMERCIAL</div>
      <div style="padding: 0.5px 0;"><strong>Règlement:</strong> VIREMENT 451 NET</div>
      <div style="padding: 0.5px 0;"><strong>Monnaie:</strong> Euros</div>
      <div style="padding: 0.5px 0;"><strong>Stock:</strong> DEPO</div>
    </div>

    <hr style="margin: 6px 0; border: 0.5px solid #000;">

    <!-- Tableau des articles -->
    <table class="items-table" style="width: 100%; border-collapse: collapse; font-size: 8px; margin-bottom: 8px;">
      <thead>
        <tr>
          <th style="border: 0.5px solid #000; padding: 2px; text-align: left;">THÈME</th>
          <th style="border: 0.5px solid #000; padding: 2px; text-align: left;">CODE ARTICLE</th>
          <th style="border: 0.5px solid #000; padding: 2px; text-align: left;">couleur</th>
          <th style="border: 0.5px solid #000; padding: 2px; text-align: left;">taille</th>
          <th style="border: 0.5px solid #000; padding: 2px; text-align: left;">designation</th>
          <th style="border: 0.5px solid #000; padding: 2px; text-align: left;">CODE EAN</th>
          <th style="border: 0.5px solid #000; padding: 2px; text-align: left;">COMPOSITION</th>
          <th style="border: 0.5px solid #000; padding: 2px; text-align: center;">QTE</th>
          <th style="border: 0.5px solid #000; padding: 2px; text-align: right;">PLU BRUT HT</th>
          <th style="border: 0.5px solid #000; padding: 2px; text-align: center;">REMISE</th>
          <th style="border: 0.5px solid #000; padding: 2px; text-align: right;">MONTANT NET HT</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="border: 0.5px solid #000; padding: 2px;">ETRIER</td>
          <td style="border: 0.5px solid #000; padding: 2px;">BABYATOUTPRIR9-ELU0129M</td>
          <td style="border: 0.5px solid #000; padding: 2px;">chocolat</td>
          <td style="border: 0.5px solid #000; padding: 2px;">-</td>
          <td style="border: 0.5px solid #000; padding: 2px;">Sac porté épaule</td>
          <td style="border: 0.5px solid #000; padding: 2px;">3663779407424</td>
          <td style="border: 0.5px solid #000; padding: 2px;">Cuir de vachette</td>
          <td style="border: 0.5px solid #000; padding: 2px; text-align: center;">1</td>
          <td style="border: 0.5px solid #000; padding: 2px; text-align: right;">0,00</td>
          <td style="border: 0.5px solid #000; padding: 2px; text-align: center;">0,00%</td>
          <td style="border: 0.5px solid #000; padding: 2px; text-align: right;">0,00</td>
        </tr>
        <tr>
          <td style="border: 0.5px solid #000; padding: 2px;">ETRIER</td>
          <td style="border: 0.5px solid #000; padding: 2px;">BABYATOUTPRIR9-ELU0129M</td>
          <td style="border: 0.5px solid #000; padding: 2px;">noir</td>
          <td style="border: 0.5px solid #000; padding: 2px;">-</td>
          <td style="border: 0.5px solid #000; padding: 2px;">Sac porté épaule</td>
          <td style="border: 0.5px solid #000; padding: 2px;">3663779407417</td>
          <td style="border: 0.5px solid #000; padding: 2px;">Cuir de vachette</td>
          <td style="border: 0.5px solid #000; padding: 2px; text-align: center;">1</td>
          <td style="border: 0.5px solid #000; padding: 2px; text-align: right;">0,00</td>
          <td style="border: 0.5px solid #000; padding: 2px; text-align: center;">0,00%</td>
          <td style="border: 0.5px solid #000; padding: 2px; text-align: right;">0,00</td>
        </tr>
      </tbody>
    </table>

    <hr style="margin: 6px 0; border: 0.5px solid #000;">

    <!-- Totaux -->
    <div class="totals" style="width: 200px; margin-left: auto; margin-bottom: 8px; font-size: 10px;">
      <div class="total-row" style="display: flex; justify-content: space-between; padding: 1px 0;">
        <span>TOTAL HT</span>
        <span>0,00 €</span>
      </div>
      <div class="total-row" style="display: flex; justify-content: space-between; padding: 1px 0;">
        <span>REMISE 0%</span>
        <span>0,00 €</span>
      </div>
      <div class="total-row" style="display: flex; justify-content: space-between; padding: 1px 0;">
        <span>FRAIS DE PORT</span>
        <span>0,00 €</span>
      </div>
      <div class="total-row" style="display: flex; justify-content: space-between; padding: 1px 0;">
        <span>TOTAL H.T</span>
        <span>0,00 €</span>
      </div>
      <div class="total-row" style="display: flex; justify-content: space-between; padding: 1px 0;">
        <span>TVA</span>
        <span>0,00 €</span>
      </div>
      <div class="total-row total-ttc" style="display: flex; justify-content: space-between; padding: 2px 0; border-top: 0.5px solid #000; font-weight: bold;">
        <span>TOTAL TTC</span>
        <span>0,00 €</span>
      </div>
    </div>

    <!-- Conditions -->
    <div class="conditions" style="font-size: 9px;text-align: center; line-height: 1.1;">
      <div style="padding: 0.5px 0;"><strong>Excompte 2% pour règlement sous 10 jours date de facture</strong></div>
      <div style="padding: 0.5px 0;">Pénalités de retard : trois fois le taux d'intérêt légal.</div>
      <div style="padding: 0.5px 0;">Indemnité forfaitaire pour frais de recouvrement si paiement effectué après la date d'échéance : 40 euros</div>
      <div style="padding: 0.5px 0;">Conditions générales de vente applicables en dernière page</div>
    </div>
  </div>
</div>
    `

    tempDiv.style.position = 'absolute'
    tempDiv.style.left = '-9999px'
    tempDiv.style.top = '0'
    tempDiv.style.width = '700px'
    document.body.appendChild(tempDiv)

    // Convertir HTML en canvas avec échelle réduite
    const canvas = await html2canvas(tempDiv, {
      scale: 1.5, // Réduit l'échelle
      useCORS: true,
      width: 700,
      windowWidth: 700,
      logging: false
    })

    // Nettoyer
    document.body.removeChild(tempDiv)

    // Créer le PDF
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4'
    })

    const imgData = canvas.toDataURL('image/jpeg', 0.8) // Compression JPEG
    const pdfWidth = pdf.internal.pageSize.getWidth()
    const pdfHeight = pdf.internal.pageSize.getHeight()
    
    const imgWidth = canvas.width
    const imgHeight = canvas.height
    const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight)
    const imgX = (pdfWidth - imgWidth * ratio) / 2
    
    pdf.addImage(imgData, 'JPEG', imgX, 10, imgWidth * ratio, imgHeight * ratio)
    pdf.save('facture_INVDE_000000438.pdf')
    
  } catch (error) {
    console.error('Erreur lors de la génération du PDF:', error)
  }
}

onMounted(() => {
  // Démarrer la génération après un court délai pour s'assurer que tout est chargé
  setTimeout(() => {
    generatePDF()
  }, 500)
})
</script>